document.addEventListener("DOMContentLoaded", () => {

  // Initialize reviews system
  initializeJudgeReviews();

});

function initializeJudgeReviews() {

  const gridElement = document.getElementById('judgeReviewsGrid');
  const loadMoreBtn = document.getElementById('judgeLoadMore');

  if (!gridElement) return;

  let currentPage = 1;
  let isLoading = false;
  let hasMorePages = true;

  // Check if live reviews are enabled
  const isLiveMode = gridElement.querySelector('.judge-reviews-loading') !== null;

  if (!isLiveMode) {
    // Static mode - just add animations to existing cards
    animateStaticCards();
    return;
  }

  // Live mode - fetch reviews from Judge.me
  fetchReviews(currentPage);

  // Load more functionality
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
      if (!isLoading && hasMorePages) {
        currentPage++;
        fetchReviews(currentPage);
      }
    });
  }

  function fetchReviews(page = 1) {

    if (isLoading) return;
    isLoading = true;

    // Show loading state
    if (page === 1) {
      gridElement.innerHTML = '<div class="judge-reviews-loading"><p style="text-align: center; color: var(--judge-text-muted); font-size: 16px; padding: 40px;">Loading reviews...</p></div>';
    }

    // For now, we'll create sample data since Judge.me API requires server-side implementation
    // In a real implementation, you'd fetch from Judge.me's API endpoint
    setTimeout(() => {
      const sampleReviews = generateSampleReviews(page);

      if (page === 1) {
        gridElement.innerHTML = '';
      }

      sampleReviews.forEach((review, index) => {
        const reviewCard = createReviewCard(review, (page - 1) * 6 + index);
        gridElement.appendChild(reviewCard);
      });

      // Show/hide load more button
      if (loadMoreBtn) {
        if (page < 3) { // Sample: only show 3 pages worth
          loadMoreBtn.style.display = 'inline-flex';
        } else {
          loadMoreBtn.style.display = 'none';
          hasMorePages = false;
        }
      }

      isLoading = false;

    }, 800); // Simulate API delay
  }

  function generateSampleReviews(page) {
    const reviews = [
      {
        id: (page - 1) * 6 + 1,
        author: 'Sophie Martin',
        rating: 5,
        title: 'Absolutely love this!',
        body: 'This product has completely transformed my skincare routine. The texture is luxurious and absorbs beautifully. I\'ve noticed a significant improvement in my skin\'s hydration and overall appearance.',
        date: '2026-06-12',
        product: 'Premium Growth Factor Elixir',
        verified: true
      },
      {
        id: (page - 1) * 6 + 2,
        author: 'Camille Dubois',
        rating: 5,
        title: 'Weekly essential',
        body: 'I use this mask every week and it never fails to leave my skin feeling refreshed and deeply hydrated. The results are visible immediately after use.',
        date: '2026-06-08',
        product: 'Anti-Aging Face Mask',
        verified: true
      },
      {
        id: (page - 1) * 6 + 3,
        author: 'Eva Mueller',
        rating: 4,
        title: 'Great protection',
        body: 'Excellent sunscreen that doesn\'t leave any white residue. It\'s lightweight and comfortable to wear all day. Perfect for daily use.',
        date: '2026-06-03',
        product: 'UV Defender SPF50',
        verified: false
      },
      {
        id: (page - 1) * 6 + 4,
        author: 'Isabelle Rodriguez',
        rating: 5,
        title: 'Rich and nourishing',
        body: 'This cream has the perfect texture - rich but not greasy. It keeps my skin moisturized throughout the day and has a lovely, subtle finish.',
        date: '2026-05-28',
        product: 'Goat Milk Cream',
        verified: true
      },
      {
        id: (page - 1) * 6 + 5,
        author: 'Marie Claire',
        rating: 5,
        title: 'Dark circles be gone!',
        body: 'I noticed a dramatic reduction in my dark circles after just two weeks of use. This eye cream is definitely worth the investment.',
        date: '2026-05-20',
        product: 'Swiss Vitae Eye Cream',
        verified: true
      },
      {
        id: (page - 1) * 6 + 6,
        author: 'Nathalie Bernard',
        rating: 5,
        title: 'Special occasion must-have',
        body: 'This is my go-to beauty ritual before any special event. The results are immediate and my skin looks radiant for hours.',
        date: '2026-05-18',
        product: 'Luxury Sheet Mask',
        verified: true
      }
    ];

    return reviews;
  }

  function createReviewCard(review, index) {

    const card = document.createElement('div');
    card.className = 'judge-review-card';
    card.style.animationDelay = `${(index % 6) * 0.1}s`;

    // Generate initials for avatar
    const initials = review.author.split(' ').map(name => name[0]).join('').toUpperCase();

    // Generate stars
    const starsHTML = Array(5).fill().map((_, i) =>
      `<svg class="judge-review-star ${i < review.rating ? 'is-filled' : ''}" viewBox="0 0 20 20">
        <polygon points="10,1 12.9,7 19.5,7.6 14.5,12 16.2,18.5 10,15 3.8,18.5 5.5,12 0.5,7.6 7.1,7" />
      </svg>`
    ).join('');

    // Format date
    const formattedDate = new Date(review.date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    card.innerHTML = `
      <div class="judge-review-card__header">
        <div class="judge-review-stars">
          ${starsHTML}
        </div>
        ${review.verified ? `
          <div class="judge-review-badge">
            <svg viewBox="0 0 20 20">
              <path d="M8.5 16.5L3 11l1.5-1.5 4 4 8-8L18 7z" fill="currentColor" />
            </svg>
            Verified
          </div>
        ` : ''}
      </div>
      
      <div class="judge-review-card__body">
        <p class="judge-review-text">${review.body}</p>
      </div>
      
      <div class="judge-review-card__footer">
        <div class="judge-review-author">
          <div class="judge-review-author__avatar">
            ${initials}
          </div>
          <div class="judge-review-author__info">
            <div class="judge-review-author__name">${review.author}</div>
            <div class="judge-review-author__date">${formattedDate}</div>
          </div>
        </div>
        
        <div class="judge-review-product">
          <div class="judge-review-product__label">Product</div>
          <div class="judge-review-product__name">${review.product}</div>
        </div>
      </div>
    `;

    return card;
  }

  function animateStaticCards() {
    const cards = document.querySelectorAll('.judge-review-card');
    cards.forEach((card, index) => {
      card.style.animationDelay = `${index * 0.1}s`;
    });
  }
}

// Enhanced version for real Judge.me API integration (server-side required)
/*
async function fetchJudgeMeReviews(shopDomain, apiToken, page = 1, perPage = 6) {
  
  try {
    const response = await fetch(`https://judge.me/api/v1/reviews?api_token=${apiToken}&shop_domain=${shopDomain}&per_page=${perPage}&page=${page}&published=true`);
    
    if (!response.ok) {
      throw new Error('Failed to fetch reviews');
    }
    
    const data = await response.json();
    return data;
    
  } catch (error) {
    console.error('Judge.me API Error:', error);
    return { reviews: [] };
  }
}
*/